export default __webpack_public_path__ + "static/media/tickGray.7737f46c.svg";